import { EarnsSummary } from '../models/earns-summary.interfaces';
import { ActivityNullStateMocks } from './activity-null-state.mocks';
import { ActivityMocks } from './activity.mocks';
import { ToggleMocks } from './toggle.mocks';

export const EarnsSummaryMocks: EarnsSummary = {
  title: '',
  toggle: ToggleMocks,
  activities: ActivityMocks,
  action: {
    label: 'View Account Activity',
    url: ''
  },
  summary: {
    label: 'When will my MQDs be reflected?',
    tooltip: {
      background: '#FFF',
      color: '#0B1F66',
      hideCloseIcon: false,
      info: 'MQDs earned on eligible Delta SkyMiles American Express Cards may post within 72 hours from when the merchants posts the  transaction to American Express, but could take up to 12 weeks to show. MQDs earned on Delta Car Rentals, Delta Stays, and Delta Vacations may take up to 8 weeks after completion of travel to post. MQDs earned on eligible Japan based Delta Credit Cards may take up to 8 weeks after merchants posts the transaction to the applicable card issuer.',
      position: 'bottom-right',
      hover: false
    }
  },
  disabled: false,
  loaded: true,
  ariaLabels: { action: '' }
};

export const EarnsSummaryNullStateMocks: EarnsSummary = {
  title: '',
  toggle: ToggleMocks,
  activities: ActivityNullStateMocks,
  action: {
    label: 'View Account Activity',
    url: ''
  },
  summary: {
    label: 'When will my MQDs be reflected?',
    tooltip: {
      background: '#FFF',
      color: '#0B1F66',
      hideCloseIcon: false,
      info: 'MQDs earned on eligible Delta SkyMiles American Express Cards may post within 72 hours from when the merchants posts the  transaction to American Express, but could take up to 12 weeks to show. MQDs earned on Delta Car Rentals, Delta Stays, and Delta Vacations may take up to 8 weeks after completion of travel to post. MQDs earned on eligible Japan based Delta Credit Cards may take up to 8 weeks after merchants posts the transaction to the applicable card issuer.',
      position: 'bottom-right',
      hover: false
    }
  },
  disabled: false,
  loaded: true,
  ariaLabels: { action: 'View Account Activity' }
};
